import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentActionComponent } from './payment-action/payment-action.component';
import { PaymentErrorComponent } from './payment-error/payment-error.component';
import { PaymentLayoutComponent } from './payment-layout/payment-layout.component';
import { CommissionResolver, PaymentGuard } from './service';

const routes: Routes = [
  {
    path: 'payment',
    component: PaymentLayoutComponent,
    children: [
      {
        path: '',
        component: PaymentActionComponent,
        canActivate: [PaymentGuard],
        resolve: { data: CommissionResolver }
      },
      {
        path: 'error',
        component: PaymentErrorComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentRoutingModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/payment-routing.module.ts